import { gql } from '@apollo/client'
import { brandRowFieldsFragment } from 'modules/brands/list/queries/getDiscoveryBrands'

export const productDropFragment = gql`
  ${brandRowFieldsFragment}

  fragment ProductFields on Product {
    id
    name
    minPrice
    currency
    defaultImageUrl
    description
    isSoldOut
    extraInfoLink
    extraInfoLabel
    variantsMap {
      name
      display_order
      values {
        name
        sku_ids
        display_order
      }
    }
    variants {
      id
      name
      sku
      salePrice
      retailPrice
      inStock
      productId
      limitToSupertesters
      variantValues {
        variant
        value
      }
      primaryImageUrl
    }
  }

  fragment ProductDropFields on ProductDrop {
    id
    isPromoted
    dropsAt
    hasDropped
    heroImageFullPath
    isSoldOut
    nextDropAt
    shipsTo
    backgroundColor
    isVisible
    canParticipate
    hasPurchased
    product {
      ...ProductFields
    }
    brand {
      ...BrandRowFields
    }
  }
`
